"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKChip = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../");
var common_1 = require("../../common");
require("./GKChip.css");
/**
 * A chip is a clickable badge, used to show a set of selections in an
 * easily visible way. Chips are intended to be used to show active filters,
 * enter multiple items from a single input (like email addresses, for example),
 * and related tasks. Clicking a chip should remove it from the set.
 */
var GKChip = function (props) {
    var _a = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-chip",
    }), content = _a.content, QA = _a["data-qa"], label = _a.label, onClick = _a.onClick, passThroughProps = __rest(_a, ["content", "data-qa", "label", "onClick"]);
    // Handle keypresses. If it's a space or enter, trigger the click handler.
    var handleKeyDown = function (e) {
        if (!["Enter", " "].includes(e.key)) {
            return;
        }
        handleClick();
    };
    // Called on click or certain keypresses.
    var handleClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (react_1.default.createElement("div", __assign({}, passThroughProps, { "data-qa": QA, tabIndex: 0, role: "button", onClick: handleClick, onKeyDown: handleKeyDown }),
        label && (react_1.default.createElement("div", { "data-qa": QA + "--label", className: "gk-chip--label" },
            label,
            ":")),
        react_1.default.createElement("div", { "data-qa": QA + "--content", className: "gk-chip--content" }, content),
        react_1.default.createElement(__1.GKIcon, { name: __1.GKIconName.Clear, "data-qa": QA + "--close", className: "gk-chip--close", "aria-hidden": true })));
};
exports.GKChip = GKChip;
